import React from "react";
import "./toolTipLite.scss";

interface ToolTipLiteProps {
  overlayStyle?: React.CSSProperties;
  overlayPosition?: "left" | "center" | "right";
  overlay: React.ReactChild | React.ReactFragment | React.ReactPortal;
  children: React.ReactElement;
}

export const ToolTipLite: React.FC<ToolTipLiteProps> = (props) => {
  const modifiers: string[] = [];
  if (props.overlayPosition) {
    modifiers.push(props.overlayPosition);
  }

  return (
    <div data-testid="c-tooltip-lite" className={`c-tooltip-lite ${modifiers.map((x) => `--${x}`).join(" ")}`}>
      {props.children}
      <div className="c-tooltip-lite__overlay" style={props.overlayStyle}>
        {props.overlay}
      </div>
    </div>
  );
};
